<div
  class="page-container"
  [ngClass]="{ 'sso-container': !profileError, unified: profileError }"
>
  @if (!profileError) {
    <mat-progress-bar mode="indeterminate" />
    <div class="jumbotron mb-0">
      <div class="content row col-12">
        <div class="w-100">
          <img src="./assets/rightbridge-logo.png" alt="RightBridge" />
          <h1>Welcome to RightBridge</h1>
          <p>Please wait while we verify your credentials.</p>
        </div>
      </div>
    </div>
  } @else {
    <div class="failed-sso-content-container">
      <div class="failed-sso-decoration-container col-12 col-md-6 col-lg-7">
        <div class="content">
          <img
            src="{{ './assets/rightbridge-logo.png' }}"
            id="Polygon-1"
            class="unified-logo"
            alt="RightBridge"
          />
          <mat-icon id="Polygon-2" class="app-button-icon" svgIcon="aw_icon" />
          <mat-icon id="Polygon-3" class="app-button-icon" svgIcon="pp_icon" />
          <mat-icon id="Polygon-4" class="app-button-icon" svgIcon="iw_icon" />
          <mat-icon id="Polygon-5" class="app-button-icon" svgIcon="lw_icon" />
          <mat-icon id="Polygon-6" class="app-button-icon" svgIcon="cm_icon" />

          <app-background-decoration />
        </div>
      </div>

      <div class="display-content col-6">
        <h1>SSO - Login Error</h1>

        @if (loginError) {
          <h3>
            There was an error logging you in from your source system. Please
            contact your system administrator.
          </h3>
        } @else {
          <h3>
            There was an error loading the profile information from your source
            system. Please contact your system administrator.
          </h3>
          @if (correlationID) {
            <p>Correlation ID: {{ correlationID }}</p>
          }
          @if (traceID) {
            <p>Trace ID: {{ traceID }}</p>
          }
          <div>
            <button
              type="button"
              mat-raised-button
              color="primary"
              (click)="backToLanding()"
            >
              <mat-icon>arrow_back</mat-icon>To Landing Page
            </button>
          </div>
        }
      </div>
    </div>
  }
</div>
